import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from "./Components/Navbar";
import Home from "./Pages/Home";
import ScrollToTop from "./Components/ScrollToTop";
import ContactUs from "./Pages/ContactUs";
import Orders from "./Pages/Orders";
import { CartProvider } from "./Context/CartContext";
import PergolasAndDecks from "./Components/PergolasAndDecks";
import HomeFurniture from "./Components/HomeFurniture";
import GardenFurniture from "./Components/GardenFurniture";
import Offers from "./Components/Offers";
import WhatsAppFloatingButton from "./Components/WhatsAppFloatingButton/WhatsAppFloatingButton";
import PersonalCustomization from "./Pages/PersonalCustomization";
import ProductPage from "./Pages/ProductPage";
import Privacy from "./Pages/Statements/Privacy";
import Terms from "./Pages/Statements/Terms";
import Accessibility from "./Pages/Statements/Accessibility";
import Footer from "./Components/Footer";

// Component to handle scroll to top on route change
const ScrollToTopOnRouteChange = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [pathname]);

    return null;
};

function App() {
    return (
        <CartProvider>
            <Router>
                <div>
                    {/* Scroll to top on route change */}
                    <ScrollToTopOnRouteChange />

                    <Navbar />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/productPage" element={<ProductPage />} />
                        <Route path="/homeFurniture" element={<HomeFurniture />} />
                        <Route path="/gardenFurniture" element={<GardenFurniture />} />
                        <Route path="/pergolasAndDecks" element={<PergolasAndDecks />} />
                        <Route path="/contactUs" element={<ContactUs />} />
                        <Route path="/orders" element={<Orders />} />
                        <Route path="/offers" element={<Offers />} />
                        <Route path="/personalCustomization" element={<PersonalCustomization />} />
                        <Route path="/product-page/:id" element={<ProductPage />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/accessibility" element={<Accessibility />} />
                    </Routes>
                    <WhatsAppFloatingButton />
                    <ScrollToTop />
                    <Footer/>
                </div>
            </Router>
        </CartProvider>
    );
}

export default App;